function getDisplayNameHOC(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

export { getDisplayNameHOC }
